(function($) { "use strict";

	$(document).ready(function(){"use strict";
		
		var progressPath = document.querySelector('.progress-wrap path');
		var pathLength = progressPath.getTotalLength();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
		progressPath.style.strokeDasharray = pathLength + ' ' + pathLength;
		progressPath.style.strokeDashoffset = pathLength;
		progressPath.getBoundingClientRect();
		progressPath.style.transition = progressPath.style.WebkitTransition = 'stroke-dashoffset 10ms linear';		
		var updateProgress = function () {
			var scroll = $(window).scrollTop();
			var height = $(document).height() - $(window).height();
			var progress = pathLength - (scroll * pathLength / height);
			progressPath.style.strokeDashoffset = progress;
		}
		updateProgress();
		$(window).scroll(updateProgress);	
		var offset = 50;
		var duration = 550;
		jQuery(window).on('scroll', function() {
			if (jQuery(this).scrollTop() > offset) {
				jQuery('.progress-wrap').addClass('active-progress');
			} else {
				jQuery('.progress-wrap').removeClass('active-progress');
			}
		});				
		jQuery('.progress-wrap').on('click', function(event) {
			event.preventDefault();
			jQuery('html, body').animate({scrollTop: 0}, duration);
			return false;
		})
	});
	
})(jQuery);
$(document).ready(function () {
    initHeaderSticky()
  });
  $(window).resize(function() {
    initHeaderSticky()
  });
  $(window).scroll(function() {
    initHeaderSticky()
  });
  function initHeaderSticky() {
    if (jQuery(document).height() > jQuery(window).height()) {
      if (jQuery(this).scrollTop() > 400) {
        jQuery('.site-header  .main-navigationbar').addClass("fixed");
      } else {
        jQuery('.site-header  .main-navigationbar').removeClass("fixed");
      }
    }
  }
$(document).ready(function() {

    // address page
    $('.edit-spacer input[type="hidden"][name="_method"][value="put"]').remove();
  
  jQuery('main').insertAfter('header');
  countDownIni('.flip-countdown,.js-flip-countdown');
  
 /********* On scroll heder Sticky *********/
  /* Header always stays fixed at top - removed scroll hide behavior */

  /* Fix header position to always stay visible at top */
  document.getElementById("header-sticky").style.top = "0";
  document.getElementById("header-sticky").style.position = "fixed";
  document.getElementById("header-sticky").style.width = "100%";
  document.getElementById("header-sticky").style.zIndex = "9999";
  document.getElementById("header-sticky").style.left = "0";
  document.getElementById("header-sticky").style.right = "0";
      /********* layout js *********/
    $('.demo-btn').on('click', function (e) {
      $('body').addClass('no-scroll');
      $('.layout-section').addClass('open');
    });
    $('.demo-close').on('click', function (e) {
      e.preventDefault();
      $('body').removeClass('no-scroll');
      $('.layout-section').removeClass('open');
    });
  /********* Mobile Menu ********/  
  $('.mobile-menu-button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
        $('body').addClass('no-scroll active-menu');
        $(".mobile-menu-wrapper").toggleClass("active-menu");
        $('.overlay').addClass('menu-overlay');
    }, 50);
  }); 
  $('body').on('click','.overlay.menu-overlay, .menu-close-icon svg', function(e){
      e.preventDefault(); 
      $('body').removeClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").removeClass("active-menu");
      $('.overlay').removeClass('menu-overlay');
  });
     $(".menu-lnk.has-item").hover(function () {
    $('body').toggleClass("no-scroll");
 });
    /********* Mobile Filter Popup ********/
    // The panel (.mobile-facets) + dark scrim are shown by body.mobile-open +
    // .overlay.active ONLY. That is the single source of truth. "Filter By"
    // (a deterministic click toggle on that class) is what reliably opens it —
    // it must NOT depend on the native <details> "toggle" event firing, which
    // is why the last attempt (scrim driven by <details> toggle) stopped
    // opening. We still keep the outer <details> open attr in sync so its
    // CSS (summary::before scrim, content render) stays consistent.
    $('.mobile-facets__open').on('click', function (e) {
      // The pill sits inside the <summary>; stop it from also firing the
      // native <details> toggle and menu-drawer's own onSummaryClick, so this
      // handler is the single thing that controls the drawer + scrim.
      e.preventDefault();
      e.stopPropagation();
      var $d = $(this).closest('.mobile-facets__disclosure');
      if ($('body').hasClass('mobile-open')) {
        $d.removeAttr('open');
        $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
        $('.overlay').removeClass('active');
      } else {
        $d.attr('open', '');
        $('body').addClass('mobile-open no-scroll');
        $('.overlay').addClass('active');
      }
    });
    // Backdrop, the bottom Apply, and each filter's inner Apply all close the
    // drawer + its scrim. Bound DELEGATED on document: the inner
    // .mobile-facets__apply buttons live inside each .js-filter, and
    // FacetFiltersForm.renderFilters rewrites that .js-filter's innerHTML on
    // every filter change, destroying/re-creating the buttons and dropping any
    // directly-bound handler. Without delegation, clicking Apply after a
    // filter selection left body.mobile-open + .overlay.active behind (the
    // stuck black mask). "Clear / Remove all" (.mobile-facets__clear) is
    // intentionally NOT a close: it only AJAX re-renders, so the drawer stays
    // open.
    $(document).on('click', '.overlay, .apply-btn, .mobile-facets__apply', function () {
      $('.mobile-facets__disclosure').removeAttr('open');
      $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    });
    var $this = $('.collection');
    if ($this.hasClass("collection-leftfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("collection-rightfilter")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
  /*********  Header Search Popup  ********/
  $(".search-header a").click(function () {
    $(".search-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function () {
    $(".search-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
     
     // ============= cart popup============
 if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
      $('body').addClass('no-scroll cartOpen');
      $('.disclosure__list-wrapper').addClass('hide');
  });
    
  }

  $('body').on('click', '.overlay.cart-overlay, .mini-cart-header, .closecart', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });

    /*********coupon popup ********/
      $(document).on('click', '.coupan-icon', function () {
        $(".coupon-popup").toggleClass("active");
      });
      $(document).on('click', '.gift-icon', function () {
        $(".coupon-popup").removeClass("active");
      });
      $(document).on('click', '.close-coupon', function () {
        $(".coupon-popup").removeClass("active");
      });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });
  
/*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").addClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });
  
  /*********  Size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no-scroll");
  });
  $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
  $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no-scroll");
  });
      /******* Subscribe popup Js *******/
    if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no-scroll');
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').slideUp(); 
      $(".subscribe-overlay").removeClass("open");
      $('body').removeClass('no-scroll');
    });    
   /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").removeClass("product-list-view");
      $(".grid-product .row").addClass("product-grid-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.simple-countdown').appendTo(prod_img);
        var prod_rew = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_rew);
        var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h4');
        jQuery(this).find('.card-product').insertAfter(prod_img);
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-content');
        jQuery(this).find('.product-top-content').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-content');
        jQuery(this).find('.product-bottom-content').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.top-lable').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.simple-countdown').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h4');
        jQuery(this).find('.reviews-stars-wrap').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.wish-lbl-wrp').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.price').appendTo(prod_img);
        var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h4');
        jQuery(this).find('.card-product').insertAfter(prod_img);
      });
    });
    /*********  Multi-level accordion nav  ********/ 
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is-open')) {
            list.slideUp('fast');
            parent.removeClass('is-open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is-open');
        }
    });  
    $('.acnav-label1').click(function (event) {
    event.preventDefault();
    if(jQuery( window ).width() < 768) {
      var label = $(this);
      var parent = label.parent('.has-children1');
      var list = label.siblings('.acnav-list1');
      if (parent.hasClass('is-open')) {
          list.slideUp('fast');
          parent.removeClass('is-open');
      }
      else {
          list.slideDown('fast');
          parent.addClass('is-open');
      }
    }
  });
  /****  TAB Js ****/
  $("ul.tabs li").click(function () {
    var $this = $(this);
    var $theTab = $(this).attr("data-tab");
    if ($this.hasClass("active")) {
    } else {
      $this
        .closest(".tabs-wrapper")
        .find("ul.tabs li, .tabs-container .tab-content")
        .removeClass("active");
      $(
        '.tabs-container .tab-content[id="' +
          $theTab +
          '"], ul.tabs li[data-tab="' +
          $theTab +
          "]"
      ).addClass("active");
    }
    $(this).addClass("active");
    });
  });  

          // currency-nice-select
$('body').on('click', '.country-name .nice-select', function (e) {
  e.stopPropagation(); // Stop the event from propagating to the body
  $(this).toggleClass('open');
});
$('body').on('click', function (e) {
  $('.country-name .nice-select').removeClass('open');
});

// currency
function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
  currencyItem.addEventListener('click', function () {
    // Trigger change event on the associated select element
    var selectElement = this.closest('.country-name').querySelector('select');
    if (selectElement) {
      // Set the selected option based on the data-currency attribute of the clicked li
      selectElement.value = this.dataset.currency;
      
      // Trigger change event
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);

      // Submit the form
      currencyFormSubmit({ target: selectElement });
    }
  });
});

// load-more button scroll
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val()),
      datacollurl = $('[data-coll-url]').val();
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('[data-next-link]').val(datacollurl + "?page="+next_coll);
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-list-view, .product-grid-view').append($(responseHTML).find('.product-list-view, .product-grid-view').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.simple-countdown').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_img);
        var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h4');
        jQuery(this).find('.card-product').insertAfter(prod_img);
      });
      
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    

  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-grid-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
// product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  

// sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products_add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products_add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky


// custom review
  setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-right').find("li.active").removeClass('active');
    $('.pdp-tab-right').find("li[data-tab='pdp-tab-2']").addClass('active');
    $('.tab-content.active').removeClass('active');
    $(".tab-content[id='pdp-tab-2']").addClass('active'); 
    });
  }, 1000); 
  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
   var swiper = new Swiper(".related-sidebar-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 1,
      },
    },
  });
  /** discount slider **/
  let SwiperTop = new Swiper('.swiper--top', {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    disableOnInteraction: true
  });

 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-left")) {
    var galleryThumb = new Swiper(".gallery-thumbs-left", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        992: {
          direction: 'vertical', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
 
    var galleryMain = new Swiper(".gallery-main-left", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-right")) {
    var galleryThumb = new Swiper(".gallery-thumbs-right", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true, 
      breakpoints: {
        992: {
          direction: 'vertical', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-right", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
 var $this = $('.pdp-left-column');
if ($this.hasClass("product-slider-center")) {
    var galleryThumb = new Swiper(".gallery-thumbs-center", {
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 4,
      spaceBetween: 10,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      direction: "horizontal",  
      breakpoints: {
        992: {
          direction: 'horizontal', 
        },
        768: {
          direction: 'horizontal', 
          slidesPerView: 3,
          spaceBetween: 15,
        },
        576: {
          direction: 'horizontal', 
          slidesPerView: 4,
        },
        320: {
          direction: 'horizontal', 
          slidesPerView: 3,
        },
      },
    });
    var galleryMain = new Swiper(".gallery-main-center", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumb
      }
    });
  
    galleryMain.on('slideChangeTransitionStart', function() {
      galleryThumb.slideTo(galleryMain.activeIndex);
    });
  
    galleryThumb.on('transitionStart', function(){
      galleryMain.slideTo(galleryThumb.activeIndex);
    });
}
  var $this = $('.pdp-left-column');
  if ($this.hasClass("product-noslider")) {
    var galleryMain = new Swiper(".gallery-noslider", {
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
  /*** home banner slider **/
  var swiper = new Swiper(".home-banner-slider", {
    speed: 800,
    loop:true,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
          return '0' + number;
      }
    },  
    navigation: {
      nextEl: ".home-arrow-next",
      prevEl: ".home-arrow-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
  });

    // quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn, .show-qv', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    console.log(href);
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      var swiper = new Swiper(".qv_slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        speed: 800,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });

    });
    $('.quickview-popup').show();
  });

$('body').on('click', '.quickview_popup_data .size-select .button', function() {
   var data_val = $(this).children('input:checked').val();
   $(this).parents('.radio-buttons').find('.option-label').text(data_val);
  
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .size-select .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
         $('.quickview_popup_data .product-form__submit > svg').remove();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
  // end quickview

 /** relaterd sidebar slider js  **/
  /** bestseller slider **/
  var swiper = new Swiper(".bestseller-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".bestseller-arrow.swiper-button-next",
      prevEl: ".bestseller-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
// qv slider
  // var swiper = new Swiper(".qv_slider", {
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   loop: true,
  //   speed: 800,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });

   /** beauty slider **/
   var swiper = new Swiper(".beauty-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".beauty-arrow.swiper-button-next",
      prevEl: ".beauty-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** service slider **/
   var swiper = new Swiper(".service-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
     slidesPerView: 3,
        navigation: {
      nextEl: ".service-arrow.swiper-button-next",
      prevEl: ".service-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
      100: {
        slidesPerView: 1,
      },
    },
  });
   var swiper = new Swiper(".category-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    slidesPerView: 6,
         navigation: {
      nextEl: ".category-arrow.swiper-button-next",
      prevEl: ".category-arrow.swiper-button-prev",
    },
    breakpoints: {
      1200: {
        slidesPerView: 6,
      },
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 4,
      },
      576: {
        slidesPerView: 3,
      },
      400: {
        slidesPerView: 2,
      },
      100: {
        slidesPerView: 1,
      },
    },
  });
  //    var swiper = new Swiper(".category-slider-v2", {
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   speed: 800,
  //   slidesPerView: 6,
  //        navigation: {
  //     nextEl: ".category-v2-arrow.swiper-button-next",
  //     prevEl: ".category-v2-arrow.swiper-button-prev",
  //   },
  //   breakpoints: {
  //     1200: {
  //       slidesPerView: 6,
  //     },
  //     992: {
  //       slidesPerView: 5,
  //     },
  //     768: {
  //       slidesPerView: 4,
  //     },
  //     576: {
  //       slidesPerView: 3,
  //     },
  //     400: {
  //       slidesPerView: 2,
  //     },
  //     100: {
  //       slidesPerView: 1,
  //     },
  //   },
  // });
  /** testimonials slider **/
  var swiper = new Swiper(".testimonials-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
          return '0' + number;
      }
    },  
    navigation: {
      nextEl: ".test-arrow.swiper-button-next",
      prevEl: ".test-arrow.swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** blog slider **/
   var swiper = new Swiper(".blog-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      formatFractionCurrent: function (number) {
          return '0' + number;
      }
    },  
    navigation: {
      nextEl: ".blog-arrow.swiper-button-next",
      prevEl: ".blog-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /** partnert logo slider **/
  var swiper = new Swiper(".partner-logo-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    centeredSlides: true,
    speed: 800,
    autoplay: true,
    navigation: {
      nextEl: ".brand-arrow.swiper-button-next",
      prevEl: ".brand-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  var swiper = new Swiper(".elegant-slider", {
    slidesPerView: 1,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".elegant-arrow.swiper-button-next",
      prevEl: ".elegant-arrow.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      475: {
        slidesPerView: 1,
      },
    },
  });
  /** view slider **/
  var swiper = new Swiper(".view-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
  /***product slider */
  var swiper = new Swiper(".product-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });
   /** our team slider **/
   var swiper = new Swiper(".our-team-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });

  /** counter js **/
  $('.counting').each(function() {
      var $this = $(this),
          countTo = $this.attr('data-count');
      
      $({ countNum: $this.text()}).animate({
        countNum: countTo
      },
      {
        duration: 3000,
        easing:'linear',
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }

      });  
    });
  /********* mobile stickybar ********/
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $(".mobile-stickybar").addClass('show');
    } else {
      $(".mobile-stickybar").removeClass('show');
    }
  }); 
  /********* color open ********/
  $('.color-select-wrp').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
        $('.clr-select-box').toggleClass('clr-box-open');
        $('.color-select-wrp').toggleClass('color-select-open');
    }, 50);
  }); 
  /********* color open ********/
  $(".green-color").click(function () {
  $('body').addClass('theme-v2');
  $('body').removeClass('theme-v3');
  });
  $(".orange-color").click(function () {
    $('body').addClass('theme-v3');
    $('body').removeClass('theme-v2');
  });
  $(".box-layout-btn").click(function () {
    $('body').addClass('box-layout');
  });
  $(".full-box-btn").click(function () {
    $('body').removeClass('box-layout');
});
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
      if($('body').hasClass('mobile-open') ){
        $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
        $('.overlay').removeClass('active');
       }
  }

  if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('div');
      newDiv.className = 'mobile-lag d-flex align-items-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.country-name, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
  if($('.site-header').hasClass('header-style-one') ){
     $('.country-name, .languages').prependTo('.menu-right');
  }else{
    $('.country-name, .languages').insertAfter('.search-header');
  }
    $('.mobile-lag').remove();
  }

  
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}


// infinit scroll
function initializeAjaxinate(containerSelector) {
  var endlessScroll = new Ajaxinate({
    container: containerSelector,
    pagination: '#collection-Pagination',
    loadingText: '<img src="https://cdn.shopify.com/s/files/1/0751/3771/2446/files/813.gif?v=1692071901" class="infinity-loader">',
    callback: callbackInfiniteScroll
  });
}

function callbackInfiniteScroll() {
  countDownIni('.flip-countdown,.js-flip-countdown');

      jQuery('.product-grid-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-top-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.product-bottom-content').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.top-lable').prependTo(prod_img);
        var prod_img = jQuery(this).find('.product-top-content');
        jQuery(this).find('.simple-countdown').appendTo(prod_img);
        var prod_img = jQuery(this).find('.product-bottom-content');
        jQuery(this).find('.reviews-stars-wrap').prependTo(prod_img);
        var prod_img = jQuery(this).find('.reviews-stars-wrap');
        jQuery(this).find('.price').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.price');
        jQuery(this).find('.wish-lbl-wrp').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.wish-lbl-wrp');
        jQuery(this).find('.cart-variable').insertAfter(prod_img);
        var prod_img = jQuery(this).find('.product-top-content h4');
        jQuery(this).find('.card-product').insertAfter(prod_img);
     });
}

document.addEventListener("DOMContentLoaded", function() {
  initializeAjaxinate('.product-list-view');

  const list_view = document.querySelector(".list-view");
  if(list_view){
      list_view.addEventListener('click', function(event) {
    if (event.target.classList.contains('product-grid-view')) {
      initializeAjaxinate('.product-grid-view');
    }
  });
  }
  
});

// Yi 手动加的给slider vanity
document.querySelectorAll('.category-slider-v2').forEach(slider => {

  // ⭐ 找到当前 slider 所在 section
  const section = slider.closest('.category-slider-v2-container');
  if (!section) return;

  const next = section.querySelector('.category-v2-arrow.swiper-button-next');
  const prev = section.querySelector('.category-v2-arrow.swiper-button-prev');

  new Swiper(slider, {
    slidesPerView: 6,
    spaceBetween: 20,
    speed: 800,
    navigation: {
      nextEl: next,
      prevEl: prev,
    },
    breakpoints: {
      1200: { slidesPerView: 6 },
      992: { slidesPerView: 5 },
      768: { slidesPerView: 4 },
      576: { slidesPerView: 3 },
      400: { slidesPerView: 2 },
      100: { slidesPerView: 1 },
    },
  });

});
